import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class MobileGoalsRoute extends Route {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('store') declare storeService: Service.Store;

	override beforeModel(): Promise<void> {
		const promises = [
			this.navigationService.initialRequestsPromise,
			this.mmGoalsService.requestSpaceGoals(),
		];

		void this.mmGoalsService.requestSpaceGoalsData();

		return new Promise((resolve /*, reject*/) => {
			void Promise.allSettled(promises).then((statusArray) => {
				const rejectedRequests = statusArray.filter((item) => item.status === 'rejected');

				if (rejectedRequests.length) {
					this.infolayerService.error('There was an error requesting your data');
				} else {
					resolve();
				}
			});
		});
	}
}
